exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip.bc-tooltip{display:block;z-index:10000;opacity:1!important}.tooltip.bc-tooltip .tooltip-inner{max-width:260px;padding:8px 10px;background:#3a424e;color:#fff;border-radius:6px;font-size:12px;line-height:1.4;text-align:left}.tooltip.bc-tooltip .tooltip-arrow{display:none}.tooltip.bc-tooltip[aria-hidden=true]{visibility:hidden;opacity:0!important}.tooltip.bc-tooltip[aria-hidden=false]{visibility:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f8114ca","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/restricted/broadcast/broadcastCreate.vue
// module id = 913
// module chunks = 0